import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

// Get saved language from localStorage or default to 'ar'
const savedLanguage = localStorage.getItem('language') || 'ar';

// Set initial HTML direction and language immediately
const isRTL = savedLanguage === 'ar';
if (isRTL) {
  document.documentElement.setAttribute('dir', 'rtl');
  document.documentElement.setAttribute('lang', 'ar');
  if (document.body) {
    document.body.setAttribute('dir', 'rtl');
  }
} else {
  document.documentElement.setAttribute('dir', 'ltr');
  document.documentElement.setAttribute('lang', 'en');
  if (document.body) {
    document.body.setAttribute('dir', 'ltr');
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    lng: savedLanguage,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

